module.exports = __webpack_public_path__ + "static/media/03.dbff8e6e.jpg";